import { NotFound } from '@/features/common/components/NotFound';
import { useAuth } from '@/hooks/useAuth';
import { UserTypeEnum } from '@/models/user.model';
import { Outlet } from 'react-router-dom';

export default function AdminRoute() {
  /**
   * If user is admin, return an outlet that will render needed view
   * If not, return element that will navigate to Dashboard page probably
   */
  const { currentUser } = useAuth();

  if (currentUser.userType != UserTypeEnum.ADMIN) {
    return <NotFound />;
  }

  return <Outlet />;
}
